<template>
  <div>
    <RangeSlider v-bind="questions[0]" />

    <section class="my-8">
      <div class="flex flex-wrap -ml-8">
        <div
          class="md:w-1/2 pl-8"
          v-for="(col, i) in values"
          :key="col.heading"
        >
          <PieValues v-bind="col" :index="i" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RangeSlider from '@/components/RangeSlider.vue';
import PieValues from '@/components/PieValues.vue';

export default {
  props: ['questions'],
  components: { RangeSlider, PieValues },
  data: () => ({}),
  computed: {
    results() {
      return this.$root.results;
    },
    values() {
      return [
        {
          heading: this.results[0].heading,
          items: [
            {
              name: this.results[0].items[0].name,
              value: this.$root.seedfastDil,
              formattedValue: this.$root.seedfastDil + '%',
            },
            {
              name: this.results[0].items[1].name,
              value: this.$root.newMoneyDil,
              formattedValue: this.$root.newMoneyDil + '%',
            },
            {
              name: this.results[0].items[2].name,
              value: this.$root.totalDil,
              formattedValue: this.$root.totalDil + '%',
            },
          ],
        },
        {
          heading: this.results[1].heading,
          items: [
            {
              name: this.results[1].items[0].name,
              value: this.$root.lateSeedfastDil,
              formattedValue: this.$root.lateSeedfastDil + '%',
            },
            {
              name: this.results[1].items[1].name,
              value: this.$root.lateSeedfastDil,
              formattedValue: this.$root.lateSeedfastDil + '%',
            },
          ],
        },
      ];
    },
  },
};
</script>

<style></style>
